"use strict";
/**
 * Created by Jerker Nord on 2016-04-18.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TweakEvent = void 0;
class TweakEvent {
}
TweakEvent.ADD_MODULE = "tweakEvent_addModule";
TweakEvent.ADD_SLIDER_TO_MODULE = "tweakEvent_addSliderToModule";
exports.TweakEvent = TweakEvent;
//# sourceMappingURL=TweakEvent.js.map